import React, { useEffect, useState } from "react";
import { Page, Text, View, Document, StyleSheet } from "@react-pdf/renderer";
import { splitWord } from "../../../../../../../utils/functions";

const JobEnquiryPdf = ({
  data = {},
  TableRowLists = [],
  generatedTitles = [],
  TermsConditions,
  modeOfRecruitment,
  jobDescription,
  notes,
}) => {
  const styles = StyleSheet.create({
    page: {
      backgroundColor: "white",
      paddingHorizontal: 20,
      // paddingVertical: 30,
      fontSize: 9,
      paddingBottom: 40,
      paddingTop: 40,
      borderBottom: 1,
    },
    divider: {
      width: "100%", // Width of the divider to span the full width
      height: 1, // Height of the divider
      backgroundColor: "#000", // Divider color
      marginTop: 10, // Margin to give space before or after the divider
    },

    container: {
      flexDirection: "row",
      justifyContent: "space-between",
      marginTop: 10,
      // borderBottom: 1,
      paddingBottom: 5,
    },
    box: {
      width: "35%",
      height: 20,
      border: 1,
      padding: 5,
    },
    box1: {
      width: "25%",
      height: 20,
      border: 1,
      padding: 5,
    },
  });

  const createdAtDate = new Date(data?.created_at);

  // Format the date as "DD-MM-YYYY"
  const formattedCreatedAt =
    ("0" + createdAtDate.getDate()).slice(-2) +
    "-" +
    ("0" + (createdAtDate.getMonth() + 1)).slice(-2) +
    "-" +
    createdAtDate.getFullYear();
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={{ marginBottom: 10 }}>
          <Text
            style={{
              textAlign: "center",
              // marginTop: 25,
              fontSize: 12,
              fontFamily: "Helvetica-Bold",
              textDecoration: "underline",
            }}
          >
            JOB ENQUIRY
          </Text>
          <View style={styles.container}>
            <View
              style={{
                ...styles.box,
                height: 30,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Text>{data?.job_enquiry_number}</Text>

              {/* <Text>SSM/COUNTRY/ENQ/001-YEAR</Text> */}
            </View>
            <View
              style={{
                ...styles.box1,
                height: 30,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Text style={{ color: "black", fontSize: 10 }}>
                {formattedCreatedAt}
              </Text>
            </View>
          </View>
        </View>

        <View style={{ marginTop: 10 }}>
          <View
            style={{
              borderTop: 0.5,
              borderBottom: 0.5,
              borderLeft: 1,
              borderRight: 1,
              padding: 5,
            }}
          >
            <Text
              style={{
                color: "black",
                fontSize: 12,
                textAlign: "center",
                fontWeight: "bold",
              }}
            >
              {data?.name}
            </Text>
            <Text
              style={{
                color: "black",
                fontSize: 10,
                textAlign: "center",
                marginTop: 5,
              }}
            >
              Under the sponsorship of Soundlines Administrative Co.
            </Text>
            <Text
              style={{
                color: "black",
                fontSize: 10,
                textAlign: "center",
                marginTop: 5,
              }}
            >
              Riyad
            </Text>
            <Text
              style={{
                color: "black",
                fontSize: 10,
                textAlign: "center",
                marginTop: 5,
              }}
            >
              Saudi Arabia
            </Text>
          </View>
        </View>

        <View
          style={{
            width: "100%",
            // border: 1,
            marginTop: 10,
            borderBottom: 1,
          }}
        >
          {/* titles */}
          <View
            style={{
              flexDirection: "row",
              width: "100%",
              borderTop: 0.5,
              borderBottom: 0.5,
              borderLeft: 1,
            }}
          >
            <View
              style={{
                // height: 40,
                backgroundColor: "#ddd",
                padding: 3,
                paddingVertical: 6,
                width: `${100 / generatedTitles.length}%`,
                borderRight: 1,
                fontSize: 8,
                fontFamily: "Helvetica-Bold",
                alignItems: "center",
              }}
            >
              <Text style={{ textAlign: "center" }}>Sl NO.</Text>
            </View>
            {generatedTitles?.map((item, index) => (
              <View
                style={{
                  // height: 40,
                  backgroundColor: "#ddd",
                  padding: 3,
                  paddingVertical: 6,
                  width: `${100 / generatedTitles.length}%`,
                  borderRight: 1,
                  fontSize: 8,
                  fontFamily: "Helvetica-Bold",
                  alignItems: "center",
                }}
                key={index}
              >
                <Text style={{ textAlign: "center" }}>{item?.col}</Text>
              </View>
            ))}
          </View>
          {/* rows */}
          {TableRowLists?.map((item, index) => (
            <View
              key={index}
              style={{
                flexDirection: "row",
                borderTop: 0.5,
                borderBottom: 0.5,
                borderLeft: 1,
              }}
            >
              <View
                style={{
                  padding: 3,
                  width: `${100 / generatedTitles.length}%`,
                  borderRight: 1,
                  fontSize: 8,
                }}
              >
                <Text style={{ textAlign: "center" }} break>
                  {index + 1}
                </Text>
              </View>
              {generatedTitles?.map((head, headIndx) => (
                <View
                  key={headIndx}
                  style={{
                    paddingHorizontal: 3,
                    paddingVertical: 2,
                    width: `${100 / generatedTitles.length}%`,
                    borderRight: 1,
                    fontSize: 8,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Text
                    style={{
                      textAlign: "center",
                      width: "100%",
                    }}
                    break
                  >
                    {splitWord(item[head?.title], 9)}
                  </Text>
                </View>
              ))}
            </View>
          ))}
        </View>
        </Page>
        {/* JOB DESCRIPTION */}
        <Page size="A4" style={styles.page}>
        <View style={{ marginTop: 15 }}>
          <View
            style={{
              backgroundColor: "#ddd",
              borderTop: 0.5,
              borderLeft: 1,
              borderRight: 1,
            }}
          >
            <View
              style={{ width: "100%", padding: 6, justifyContent: "center" }}
            >
              <Text style={{ fontSize: 12, textAlign: "center" }}>
                JOB DESCRIPTION
              </Text>
            </View>
          </View>
          <View
            style={{
              borderBottomWidth: 0.5,
              borderLeftWidth: 1,
              borderRightWidth: 1,
              padding: 5,
              justifyContent: "center",
            }}
          >
            {jobDescription?.map((list, index) => (
              <View
                style={{
                  marginBottom: 10,
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                  alignItems: "flex-start", // Ensures the alignment starts at the top
                }}
                key={index}
              >
                <Text style={{ fontSize: 10 }}>{index + 1}) </Text>
                <View style={{ flex: 1, marginLeft: 5 }}>
                  {" "}
                  {/* Add some margin for space between index and text */}
                  <Text
                    style={{
                      color: "black",
                      fontSize: 10,
                      padding: 2, // Adds internal padding to avoid overlap
                    }}
                    numberOfLines={null} // Ensure the text wraps properly
                    adjustsFontSizeToFit={false} // Prevents font shrinking
                  >
                    {list?.description}
                  </Text>
                  {/* <View style={styles.divider} /> */}
                </View>
              </View>
            ))}
          </View>
        </View>
        <View style={{ marginTop: 15 }}>
          <View
            style={{
              backgroundColor: "#ddd",
              borderTop: 0.5,
              //   borderBottom: 0.5,
              borderLeft: 1,
              borderRight: 1,
            }}
          >
            <View style={{ width: "100%", padding: 6 }}>
              <Text style={{ fontSize: 12, textAlign: "center" }}>
                MODE OF RECRUITMENT
              </Text>
            </View>
          </View>
          <View
            style={{
              //   borderTop: 0.5,
              borderBottom: 0.5,
              borderLeft: 1,
              borderRight: 1,
              padding: 5,
              justifyContent: "center",
            }}
          >
            {modeOfRecruitment?.map((list, index) => (
              <View
                style={{
                  marginBottom: 10,
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
                key={index}
              >
                <Text>{index + 1}) </Text>
                <View>
                  <Text style={{ color: "black", fontSize: 10 }}>
                    {list?.name}
                  </Text>
                  <Text style={{ color: "black", fontSize: 10, width: "90%" }}>
                    {list?.description}
                  </Text>
                </View>
              </View>
            ))}
          </View>
        </View>

        <View style={{ marginTop: 17, textAlign: "center" }}>
          {/* row 1 */}
          <View
            style={{
              backgroundColor: "#ddd",
              borderTop: 0.5,
              //   borderBottom: 0.5,
              borderLeft: 1,
              borderRight: 1,
            }}
          >
            <View style={{ width: "100%", padding: 6 }}>
              <Text style={{ fontSize: 12, textAlign: "center" }}>
                TERMS & CONDITIONS:
              </Text>
            </View>
          </View>
          {TermsConditions?.map((item, index) => (
            <View
              key={index}
              style={{
                flexDirection: "row",
                borderTop: 0.5,
                borderBottom: 0.5,
                borderLeft: 1,
                borderRight: 1,
              }}
            >
              {/* { profession: "", reqno: " ", salary: " " ,allowance:""}, */}
              <View style={{ width: "10%", padding: 5, borderRight: 1 }}>
                <Text break>{index + 1}</Text>
              </View>
              <View style={{ width: "35%", padding: 5, borderRight: 1,textAlign : "left" }}>
                <Text break>{item.particular}</Text>
              </View>
              <View style={{ width: "55%", padding: 5, borderRight: 1,textAlign : "left" }}>
                <Text break>{item.remark}</Text>
              </View>
            </View>
          ))}
        </View>

        <View style={{ marginTop: 10 }}>
          {notes?.map((item, index) => (
            <View style={{ marginTop: 10 }} key={index}>
              <Text>Note - {item?.description}</Text>
            </View>
          ))}
        </View>
        <View style={{ marginTop: 10, fontFamily: "Helvetica-Bold" }}>
          <Text>Regards,</Text>
          <Text style={{ marginTop: 25 }}>Vinod D’cunha</Text>
          <Text>Chief Operations Manager</Text>
        </View>
        
      </Page>
      {/* <View style={styles.divider} /> */}
    </Document>
  );
};
export default JobEnquiryPdf;
